import { render, staticRenderFns } from "./ResultButton.vue?vue&type=template&id=f90b044c&"
import script from "./ResultButton.vue?vue&type=script&lang=js&"
export * from "./ResultButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports